// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3x8Di","author":"Table_author__Chy5P","authorImage":"Table_authorImage__1GGTp","unreadRow":"Table_unreadRow__13YXj"};